import Cookies from 'js-cookie'

export const getMainCookieDomain = (hostname = location?.host) => hostname.substring(hostname.indexOf('.'))

export const getCookieValue = name => Cookies.get(name)

export const getAllCookieNames = () => {
  const cookies = Cookies.get()
  return Object.keys(cookies).map(c => c.trim())
}

export const writeCookie = (name, value, domain, path = '/', sameSite = 'None', secure = true, expires = 365) => {
  Cookies.set(name, value, { domain, path, sameSite, secure, expires })
}

export const deleteCookie = (name, domain, path = '/', sameSite = 'None', secure = true) =>
  Cookies.remove(name, { domain, path, sameSite, secure })

export const deleteCookieOnAllDomains = (name, domain = location.host, path = '/') => {
  Cookies.remove(name, { path, domain }) // remove cookie on fr.mappy.com
  Cookies.remove(name, { path, domain: `.${domain}` }) // remove cookie on .fr.mappy.com (yes, I’m speaking to you cto_bundle)
  Cookies.remove(name, { path, domain: getMainCookieDomain(domain) }) // remove cookie on .mappy.com
}
